<template lang="pug">
.robot-spec.w
  .row(v-for="item in list")
    .col1
      i(v-if="item.icon", :class="[item.icon]")
      p {{item.title}}
    .params
      .param(v-for="item2 in item.params")
        .col2 {{item2[0]}}
        template(v-if="typeof item2[1] === 'string'")
          .col3 {{item2[1]}}
        template(v-else)
          .col3
            p(v-for="item3 in item2[1]") {{item3}}
</template>

<script>
import specData from '../../config/spec'

export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    let type = this.$route.fullPath.split('/')[1]
    this.list = specData[type]
  },
}
</script>

<style lang="stylus">
@import 'config'
.robot-spec
  padding 40px 0
  .row
    border-bottom 1px solid $bdcolor
    display flex
    align-items center
    justify-content center
    .col1
      width 320px
      height 100%
      text-align center
      font-size 18px
      color #666
      i
        display inline-block
        width 30px
        height 30px
        background-position center
        background-repeat no-repeat
      .icon-camera
        background-image url('../../assets/web/icon-camera.png')
      .icon-voicebox
        background-image url('../../assets/web/icon-voicebox.png')
      .icon-mic
        background-image url('../../assets/web/icon-mic.png')
      .icon-screen
        background-image url('../../assets/web/icon-screen.png')
      .icon-hardware
        background-image url('../../assets/web/icon-hardware.png')
      .icon-move
        background-image url('../../assets/web/icon-move.png')
      .icon-wifi
        background-image url('../../assets/web/icon-wifi.png')
      .icon-battery
        background-image url('../../assets/web/icon-battery.png')
      .icon-sensor
        background-image url('../../assets/web/icon-sensor.png')
    .params
      flex 1
      padding 50px 0 50px 65px
      color #999
      font-size 14px
      border-left 1px solid $bdcolor
      .param
        display flex
        line-height 40px
        .col2
          width 180px
        .col3
          flex 1
</style>



// WEBPACK FOOTER //
// src/views/robot/spec.vue